import { createSlice } from '@reduxjs/toolkit';

type State = {
    msg: string,
    type: string
}

const initialState = {
    msg: "",
    type: "",
}

const notification = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        showSuccessNotification: (state: State, action) => {
            state.msg = action.payload;
            state.type = "success";
        },
        showErrorNotification: (state: State, action) => {
            state.msg = action.payload;
            state.type = "error";    
        },
        showWarningNotification: (state: State, action) => {
            state.msg = action.payload;
            state.type = "warning";
        },
        hideNotification: (state: State) => {
            state.msg = "";
            state.type = "";     
        }
    }
});

// Actions
export const {
    showSuccessNotification,
    showErrorNotification,
    showWarningNotification,
    hideNotification
} = notification.actions;

export default notification.reducer;

// Thunk
export const showNotification = (type: string, msg: string) => async (dispatch: Function) => {
    switch (type) {
        case "error":
            dispatch(showErrorNotification(msg));
            break;
        case "warning":
            dispatch(showWarningNotification(msg));
            break;
        default:
            dispatch(showSuccessNotification(msg));
            break;
    }

    setTimeout(() => {
       dispatch(hideNotification()) 
    }, 5000);
}
